import React from 'react';
import VendorDetailsFields from './VendorDetailsFields';

function EditVendor({ VendorData, sendDataToParent }) {
  const handleData = (data) => {
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <VendorDetailsFields formData={VendorData} sendDataToParent={handleData} />
    </div>
  );
}

export default EditVendor;
